module.exports = __webpack_public_path__ + "img/medal3.c83276b3.png";